import { render, staticRenderFns } from "./SmartPN.vue?vue&type=template&id=4840aa40&scoped=true"
import script from "./SmartPN.vue?vue&type=script&lang=ts"
export * from "./SmartPN.vue?vue&type=script&lang=ts"
import style0 from "./SmartPN.vue?vue&type=style&index=0&id=4840aa40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4840aa40",
  null
  
)

export default component.exports